/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {Box, Heading, Text} from '@salesforce/retail-react-app/app/components/shared/ui'

const PromoCodeDisplay = ({priceAdjustments, loyaltyCouponCode}) => {
    const promoCodePriceAdjustments = priceAdjustments?.filter(
        (priceAdjustment) => priceAdjustment?.couponCode && priceAdjustment.couponCode !== loyaltyCouponCode
    )

    return (
        <>
            {promoCodePriceAdjustments?.length > 0 && (
                <Box borderBottom="1px solid" borderBottomColor="cardDivider" pb={4}>
                    <Heading
                        as="h2"
                        fontSize="md"
                        fontWeight="700"
                        mb="2"
                        textTransform="uppercase"
                        lineHeight="5"
                    >
                        <FormattedMessage
                            defaultMessage="Promo Code"
                            id="use_promo_code_fields.label.promo_code"
                        />
                    </Heading>
                    {promoCodePriceAdjustments?.map((priceAdjustment) => (
                        // data-private: the applied coupon (promo name + code) is redacted from LogRocket replays
                        <Box key={priceAdjustment.priceAdjustmentid} fontSize={'sm'} data-private>
                            <Text fontWeight="700" lineHeight="4">{priceAdjustment.c_calloutMsg || priceAdjustment.itemText}</Text>
                            <Text lineHeight="18px">{priceAdjustment.couponCode}</Text>
                        </Box>
                    ))}
                </Box>
            )}
        </>
    )
}

PromoCodeDisplay.propTypes = {
    priceAdjustments: PropTypes.array,
    loyaltyCouponCode: PropTypes.string
}

export default PromoCodeDisplay
